const constants = {
  mixpanel: {
    open_home_action: "Open Home Screen",
  }
};

export default constants;
